module.exports = __webpack_public_path__ + "img/Nicole Vazquez.6bbc0f2e.jpg";